var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 12,
    viewBox: "0 0 101 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.29115,
    cy: 6,
    r: 4.21913,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.553,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6385,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7242,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8096,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8953,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9808,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0665,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1519,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.2376,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.3231,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.4087,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.4942,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5799,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.6653,
    cy: 6,
    r: 1.04278,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.708 1.29841L92.708 10.7025C92.7083 10.7977 92.7346 10.891 92.784 10.9724C92.8334 11.0538 92.904 11.1202 92.9883 11.1644C93.0727 11.2086 93.1674 11.229 93.2625 11.2234C93.3575 11.2178 93.4492 11.1863 93.5277 11.1324L100.32 6.43042C100.601 6.23554 100.601 5.76639 100.32 5.57099L93.5277 0.86896C93.4494 0.814534 93.3577 0.782618 93.2624 0.776678C93.1672 0.770738 93.0722 0.791003 92.9877 0.83527C92.9032 0.879537 92.8325 0.946113 92.7832 1.02777C92.7339 1.10942 92.7079 1.20302 92.708 1.29841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketArrow);
export default __webpack_public_path__ + "static/media/ticket_arrow.d368b876bf63db143eceacfa3cd4b2de.svg";
export { ForwardRef as ReactComponent };